import usePaginatedData from './use-paginated-data';
import { APIApartmentItemLikable, MarketTypes } from 'api/types';
import { transformApartmentItem } from 'api/transformers';
import useApartmentsFilterQuery from './use-aparments-filter-query';
import { ApartmentListItemProps } from 'components/apartment-list-item';
import useApartmentsSortQuery from './use-apartment-sort-query';

export type APIApartmentDealsRes = {
  items: APIApartmentItemLikable[];
  count: number;
};

export type ApartmentDeal = Omit<ApartmentListItemProps, 'className' | 'icon'> & {
  id: number;
  availabilityStatus: { key: string; translation: string };
  buildingTitle: string;
};

const useApartmentDeals = (marketType = MarketTypes.PRIMARY) => {
  const filter = useApartmentsFilterQuery();
  const sortByField = useApartmentsSortQuery();
  const result = usePaginatedData<APIApartmentDealsRes, ApartmentDeal>(
    '/facilities/facility-list',
    'post',
    // @ts-ignore
    ({ items, count }) => {
      const apartments = items.map(transformApartmentItem);
      return { items: apartments, count };
    },
    sortByField?.field && sortByField?.direction
      ? { filter: { ...filter, marketType }, sortByField }
      : { filter: { ...filter, marketType } },
  );
  return result;
};

export default useApartmentDeals;
